import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  step: number;
  totalStep: number;
};

// display the current step and total steps in a signup flow
export default function StepCounter({
  className = '',
  step,
  totalStep,
}: Props) {
  const wrapperClass = clsx(
    className,
    'mb-2 text-text-dark-medium dark:text-text-light-medium text-base'
  );

  return (
    <p className={wrapperClass}>
      <span className="font-bold">Step {step.toString().padStart(2, '0')}</span>
      /
      <span className="text-text-dark-low dark:text-text-light-low">
        {totalStep.toString().padStart(2, '0')}
      </span>
    </p>
  );
}
